module.exports = __webpack_public_path__ + "img/device-laptop.2883cff5.svg";